import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { AVATAR_SIZES } from '@atlaskit/avatar';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { getModalMenuPortalStyles } from 'src/styles/select';

const outlineWidth = 2;
const akSortSelectWidth = `168px`;

// overrides default styling for AvatarGroup avatar
const outline = (color: string) =>
  css({
    boxShadow: `0 0 0 ${outlineWidth}px ${color}`,
    backgroundColor: `${token('elevation.surface', colors.N0)} !important`,
    outline: 'none',
  });

export const FilterAndSortSettings = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`;

export const FilterOrSortSection = styled.div`
  align-items: center;
  display: flex;
  margin-top: ${token('space.100', '8px')};
  margin-bottom: ${token('space.100', '8px')};

  & > div:first-of-type {
    color: ${token('color.text.subtlest', colors.N200)};
    margin-right: ${token('space.100', '8px')};
    text-transform: uppercase;
  }
`;

// AK Select component for "Sort by" options
export const getSortBySelectStyles = (isSiteBannerOpen: boolean) => ({
  ...getModalMenuPortalStyles(isSiteBannerOpen),
  menu: (base: Record<string, any>) => ({
    ...base,
    zIndex: 200,
  }),
  // Select components outer most layer
  container: (base: Record<string, any>) => ({
    ...base,
    flex: 1,
    maxWidth: akSortSelectWidth,
    width: akSortSelectWidth,
  }),
});

export const AvatarInnerButton = styled.button`
  &[aria-pressed='true'] {
    ${outline(colors.B400)};
  }
  &:focus {
    ${outline(colors.B200)};
  }
  & > span {
    height: ${AVATAR_SIZES.medium}px;
    background-color: ${token('color.background.input', colors.N50)};
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    display: flex;
  }
`;
